import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMsal } from '@azure/msal-react';
import { Flex } from '@chakra-ui/react';
import { MenuGroup, MenuItem, Menu, Avatar, PageHeader, Typography } from '@sgi/gravity';
import { useCallback } from 'react';
import { useRenderedUserMenuItems, useUserMenuItems } from '../../../../../shell';
export default function AppUserMenu() {
    const userMenuItems = useUserMenuItems();
    const msal = useMsal();
    const customerName = msal.accounts[0]?.idTokenClaims?.name ?? '';
    const renderMenuGroup = useCallback((category, userMenuItems) => {
        return (_jsxs(Menu, { children: [_jsx(PageHeader, { "data-testid": "user-menu-page-header", children: _jsxs(Flex, { alignItems: "center", children: [_jsx(Avatar, { size: "xl", name: customerName, "data-testid": "menu-avatar" }), _jsx(Typography, { variant: "bodyBold", paddingLeft: 5, children: customerName })] }) }), _jsx(MenuGroup, { title: category, children: userMenuItems?.map((userMenuItem, index) => _jsx(MenuItem, { children: userMenuItem.component }, `${category}-${index}`)) }, `${category}`)] }, `${category}`));
    }, []);
    const renderedUserMenuItems = useRenderedUserMenuItems(userMenuItems, renderMenuGroup);
    return _jsx(_Fragment, { children: renderedUserMenuItems });
}
